import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchTrendingTopFive } from "../../api/newsApi";
import "./TrendingMarquee.css";

/**
 * Continuously auto-scrolling strip of the 5 trending articles from
 * /api/trending-top-five. The track is rendered twice back-to-back and
 * animated -50% so the loop is seamless; hovering pauses it.
 */
function TrendingMarquee() {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let isMounted = true;

    async function load() {
      try {
        const data = await fetchTrendingTopFive();
        if (isMounted) setItems(data);
      } catch (err) {
        if (isMounted) setItems([]);
      } finally {
        if (isMounted) setLoaded(true);
      }
    }

    load();
    return () => {
      isMounted = false;
    };
  }, []);

  if (!loaded || items.length === 0) return null;

  function renderCard(news, keyPrefix) {
    return (
      <Link
        key={`${keyPrefix}-${news.id}`}
        to={`/news/${news.categorySlug}/${news.id}`}
        className="tt-marquee-card"
      >
        {news.image ? (
          <img
            src={news.image}
            alt={news.title}
            className="tt-marquee-card-img"
            loading="lazy"
          />
        ) : (
          <div
            className="tt-marquee-card-img tt-marquee-card-img-fallback"
            aria-hidden="true"
          />
        )}
        <span className="tt-marquee-card-badge">Trending</span>
        <div className="tt-marquee-card-body">
          <span className="tt-marquee-card-eyebrow">
            {news.category || "Trending"}
          </span>
          <p className="tt-marquee-card-title">{news.title}</p>
        </div>
      </Link>
    );
  }

  return (
    <div className="tt-marquee" role="region" aria-label="Trending now">
      <div className="tt-marquee-track">
        <div className="tt-marquee-group">
          {items.map((news) => renderCard(news, "a"))}
        </div>
        <div className="tt-marquee-group" aria-hidden="true">
          {items.map((news) => renderCard(news, "b"))}
        </div>
      </div>
    </div>
  );
}

export default TrendingMarquee;
